import type { InputHTMLAttributes } from "react";
import styled from "styled-components";

import { color } from "../../theme/color";

type TextFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> & { onChange(value: string): void };

/** A text field that hands `onChange` the new text, so it can go straight into state: `onChange={setName}`. */
export function TextField({ onChange, ...input }: TextFieldProps) {
    return <Input {...input} onChange={(event) => onChange(event.target.value)} />;
}

const Input = styled.input`
    height: 44px;
    width: 100%;
    padding: 0 12px;
    border: 1px solid ${color.borderStrong};
    border-radius: 10px;
    background: ${color.background};
    font-size: 16px;

    &::placeholder {
        color: ${color.textFaint};
    }
`;
